import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, ChevronRightIcon, PlusIcon, SearchIcon } from 'lucide-react';
import { FoundPetDialog } from '../components/animaux/FoundPetDialog';
import { PetAtna, PetRules } from '../components/animaux/PetAtna';
import { VetConnect } from '../components/animaux/VetConnect';
import { petTodos, pets } from '../data/animaux';
export function MesAnimaux() {
  const [foundOpen, setFoundOpen] = useState(false);
  const todos = pets.flatMap(pet => (petTodos[pet.id] ?? []).map(todo => ({
    ...todo,
    pet
  })));
  return <main className="bg-white" data-id="element-2119" data-mp="20n7l9jzx111h">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2120" data-mp="20ld0c5on98xe">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2121" data-mp="1vnbh9kr7x9lx">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2122" data-mp="2ak2kk540j5gt">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2123" data-mp="25nc4viw4ebvx" />
          <span aria-current="page" data-id="element-2124" data-mp="1jl05tjngwppg">Mes animaux</span>
        </nav>

        <header className="mt-4" data-id="element-2125" data-mp="1ojbg1vhod287">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2126" data-mp="1okcqbxqv9kov">Mes animaux</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2127" data-mp="1sk52ekfgy8yz">
            Vos animaux, leurs médailles et ce qui compte — au même endroit.
          </p>
        </header>

        <div className="mt-8" data-id="element-2128" data-mp="22jm7p0qt6kuf">
          <PetAtna data-id="element-2129" data-mp="22ikuoqq8foa2" />
        </div>

        <section aria-labelledby="animaux-titre" className="mt-14" data-id="element-2130" data-mp="22h9oyld886gb">
          <h2 id="animaux-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2131" data-mp="27gmdrbnnrnlj">
            Mes animaux
          </h2>

          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-2132" data-mp="2gahg6bxeazxh">
            {pets.map(pet => <li key={pet.id} className="flex" data-id="element-2133" data-mp="2l9lshbfm9ds1">
                <Link to={`/mes-animaux/${pet.id}`} className="group flex w-full items-center gap-4 rounded-3xl border border-slate-200 bg-white p-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2134" data-mp="2lawt52drm5ex">
                  <img src={pet.photo} alt={pet.name} className="h-24 w-24 shrink-0 rounded-2xl object-cover" data-id="element-2135" data-mp="zw8lv7jsm03d" />
                  <div className="min-w-0 flex-1" data-id="element-2136" data-mp="v5s97pnsqii2">
                    <p className="text-lg font-extrabold text-ville-navy" data-id="element-2137" data-mp="v3xoocgfssei">{pet.name}</p>
                    <p className="text-sm text-slate-500" data-id="element-2138" data-mp="18vlw42fqqsp5">
                      {pet.breed} · {pet.age}
                    </p>
                    <p className="mt-2 inline-flex rounded-full bg-ville-indigo-soft px-3 py-1 text-xs font-bold text-ville-indigo" data-id="element-2139" data-mp="14xeez6hd7pdf">
                      Médaille active
                    </p>
                    <p className="mt-2 font-mono text-xs tracking-widest text-slate-500" data-id="element-2140" data-mp="1dtx7ihlopb9h">{pet.medal}</p>
                    <p className="text-xs text-slate-500" data-id="element-2141" data-mp="3kok8nlbau3et">Validité : {pet.validUntil}</p>
                    <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2142" data-mp="3fp7juv0vam9l">
                      Voir la carte
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2143" data-mp="2069njn68u3ah" />
                    </span>
                  </div>
                </Link>
              </li>)}

            <li className="flex" data-id="element-2144" data-mp="1qcj26r5ey8z0">
              <button type="button" className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2145" data-mp="1cf47p80azb06">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2146" data-mp="17hkw6fuzpcbx">
                  <PlusIcon className="h-6 w-6" data-id="element-2147" data-mp="31tsij4t8wkw3" />
                </span>
                <span className="text-[15px] font-bold text-ville-navy" data-id="element-2148" data-mp="31szjyr4fx1p1">Ajouter un animal</span>
              </button>
            </li>

            <li className="flex" data-id="element-2149" data-mp="xq7i59fm3t3w">
              <button type="button" onClick={() => setFoundOpen(true)} className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2150" data-mp="xr94wb5zq41g">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2151" data-mp="e0nnd2wd0lev">
                  <SearchIcon className="h-6 w-6" data-id="element-2152" data-mp="9xzckpo354f9" />
                </span>
                <span data-id="element-2153" data-mp="52tszxi5o1uc">
                  <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2154" data-mp="4zfoaim0rgjq">Animal trouvé</span>
                  <span className="block text-sm text-slate-500" data-id="element-2155" data-mp="40dy0n802s2">Scanner son collier ou signaler</span>
                </span>
              </button>
            </li>
          </ul>
        </section>

        <section aria-labelledby="a-faire-titre" className="mt-14" data-id="element-2156" data-mp="3h6mss8osfa38">
          <h2 id="a-faire-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2157" data-mp="3m2bvum00n94a">
            À faire
          </h2>
          {todos.length === 0 ? <p className="mt-3 flex items-center gap-2 text-sm text-slate-500" data-id="element-2158" data-mp="3w22osj8xhg29">
              <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-2159" data-mp="2yeaohgekpyqg" />
              Tout est à jour.
            </p> : <ul className="mt-5 space-y-3" data-id="element-2160" data-mp="33dnbc15g35t1">
              {todos.map(todo => <li key={`${todo.pet.id}-${todo.id}`} data-id="element-2161" data-mp="38b6zptvuwyyp">
                  <Link to={`/mes-animaux/${todo.pet.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2162" data-mp="3d2ygjcp7nqbn">
                    <img src={todo.pet.photo} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover" data-id="element-2163" data-mp="2ck51drpp9e3s" />
                    <span className="min-w-0 flex-1" data-id="element-2164" data-mp="27ksgvdmawj4d">
                      <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2165" data-mp="2mc13reytjqdt">
                        {todo.title} — {todo.pet.name}
                      </span>
                      <span className="block text-sm text-slate-500" data-id="element-2166" data-mp="1tn3qxrddmlsg">{todo.detail}</span>
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2167" data-mp="1ooirvv9v285l">
                      {todo.cta}
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2168" data-mp="1ylx6dpc84mv9" />
                    </span>
                  </Link>
                </li>)}
            </ul>}
        </section>

        <PetRules data-id="element-2169" data-mp="3a0aki2h6dny3" />
        <VetConnect data-id="element-2170" data-mp="3a12dr6nav9l7" />
      </div>

      <FoundPetDialog open={foundOpen} onClose={() => setFoundOpen(false)} data-id="element-2171" data-mp="3hkuw3r3hamc5" />
    </main>;
}